import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CONTACT } from "../../lib/content";

const links = [
  { label: "Services", href: "#services" },
  { label: "Areas", href: "#areas" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why" },
  { label: "Reviews", href: "#reviews" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#F9F6F0]/80 backdrop-blur-xl border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-left leading-none"
        >
          <span className={`font-display text-2xl md:text-[27px] ${scrolled ? "text-foreground" : "text-white"}`}>
            Rest Assured
          </span>
          <span className={`block label-eyebrow mt-0.5 ${scrolled ? "text-muted-foreground" : "text-white/70"}`}>
            Group Travel LLC
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(l.href)}
              className={`label-eyebrow transition-colors hover:text-primary ${
                scrolled ? "text-foreground" : "text-white/90"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-phone"
            href={CONTACT.phoneHref}
            className={`hidden lg:block label-eyebrow transition-colors hover:text-primary ${
              scrolled ? "text-foreground" : "text-white/90"
            }`}
          >
            {CONTACT.phone}
          </a>
          <button
            data-testid="header-cta"
            onClick={() => go("#contact")}
            className="bg-primary text-primary-foreground px-5 md:px-7 py-3 label-eyebrow hover:bg-[#a04d2d] transition-colors"
          >
            Request Services
          </button>
        </div>
      </div>
    </motion.header>
  );
};
